import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import { MdxPage } from '@features/mdx/MdxPage';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b',
	[AppLanguageCodes.SK]: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b',
	[AppLanguageCodes.DE]: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b',
}


export const Partners = () => {
	const { t } = useTranslation('web');

	return (
		<MdxPage className='partners-page' articleIds={articleIds}>
			
			<div className='partners-links'>
				<Link to={NavigateRoutes.partnersOrder} className='app-form-button disable-selection'>
					{t('pages.partners.partnersOrderLink')}
				</Link>

				<Link to={NavigateRoutes.partnersRegistration} className='app-form-button disable-selection'>
					{t('pages.partners.registrationLink')}
				</Link>
			</div>
		
		</MdxPage>
	);
};